/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Basicinformation1Inputs */

const en_common_basicinformation1 = /** @type {(inputs: Common_Basicinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic Information`)
};

/**
* | output |
* | --- |
* | "Basic Information" |
*
* @param {Common_Basicinformation1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_basicinformation1 = /** @type {((inputs?: Common_Basicinformation1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Basicinformation1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_basicinformation1(inputs)
});
export { common_basicinformation1 as "common_basicInformation" }